<template>
  <footer class="footer">
      <div class="footer-wrap">
        <ul class="nav-menu">
            <li class="nav-menu-item"><router-link to="about-us" :class="'nav-menu-item-link'">About Us</router-link></li>
            <li class="nav-menu-item"><a href="#download-mobile-app" @click.prevent="download" class="nav-menu-item-link">Download Mobile App</a></li>
            <li class="nav-menu-item"><router-link to="careers" :class="'nav-menu-item-link'">Careers</router-link></li>
            <li class="nav-menu-item"><router-link to="contact" :class="'nav-menu-item-link'">Contact</router-link></li>
            <li class="nav-menu-item"><router-link to="faq" :class="'nav-menu-item-link'">FAQ</router-link></li>
            <li class="nav-menu-item"><router-link to="privacy-policy" :class="'nav-menu-item-link'">Privacy</router-link></li>
            <li class="nav-menu-item"><router-link to="terms" :class="'nav-menu-item-link'">Terms</router-link></li>
        </ul>
        <p class="quote">
            *We provide our customers with online chat system to enable them communicate with us during business hours. 
            All enquiries, whether made through e-mail, phone, or Live Support™, would be responded to not later than 48 hours from time of receipt. 
        </p>
        <ul class="nav-social">
            <li class="nav-social-item"><a class="nav-social-item-link" href="#"><twitter></twitter></a></li>
            <li class="nav-social-item"><a class="nav-social-item-link" href="#"><facebook></facebook></a></li>
            <li class="nav-social-item"><a class="nav-social-item-link" href="#"><skype></skype></a></li>
            <li class="nav-social-item"><a class="nav-social-item-link" href="#"><instagram></instagram></a></li>
        </ul>
        <div class="copyright">
            <p>Copyright © 2015 TopUp Africa</p>
            <div class="securecode">
            <img src="../assets/img/mastercard-securecode.png" alt="">
            <img src="../assets/img/verified-by-visa.png" alt="">
            </div>
        </div>
      </div>
    </footer>
</template>

<script>
import twitter from '../assets/icons/twitter';
import facebook from '../assets/icons/facebook';
import skype from '../assets/icons/skype';
import instagram from '../assets/icons/instagram';

export default {
  data() {
    return {};
  },
  methods: {
    download() {
      window.open('https://goo.gl/6t2RQg', '_blank');
    }
  },
  components: {
    twitter,
    facebook,
    skype,
    instagram
  }
};
</script>



// WEBPACK FOOTER //
// src/components/footer.vue